import React, { useState, useEffect, useContext } from 'react'
import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import StrengthIcon from '../../../../Assets/Images/STRENGTH.png';
import SoulIcon from '../../../../Assets/Images/SOUL.png';
import MindIcon from '../../../../Assets/Images/MIND.png';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

const QUADRANT_HIERARCHY = {
  heart: 0,      // Highest priority
  soul: 1,
  mind: 2,
  strength: 3    // Lowest priority
};

const compareQuadrants = (a, b) => {
  const valueDiff = (b.avg ?? b.avg ?? 0) - (a.avg ?? a.avg ?? 0);
  if (valueDiff !== 0) return valueDiff;

  // If values are equal, compare by hierarchy (ascending - lower number = higher priority)
  const aHierarchy = QUADRANT_HIERARCHY[a.name?.toLowerCase()] ?? 999;
  const bHierarchy = QUADRANT_HIERARCHY[b.name?.toLowerCase()] ?? 999;
  return aHierarchy - bHierarchy;
};

export default function HeartStarterQuadrantGroup({ apiData, previewData, reportType, pageNumber }) {
  const groupReportCtx = useContext(GroupReportContext)
  const { averagePercentages } = groupReportCtx;


  const [highestStarter, setHighestStarter] = useState('')
  const [quadrantPercentages, setQuadrantPercentages] = useState({
    strength: 0,
    heart: 0,
    soul: 0,
    mind: 0
  })

  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});


  // useEffect(() => {
  //   if (previewData && Array.isArray(previewData) && previewData.length > 0 && apiData?.teamname) {
  //     // Find the team data that matches apiData.teamname
  //     const teamData = previewData.find(team => team.teamname === apiData.teamname);
  //     // console.log("Found team data:", teamData);

  //     if (teamData && teamData.results && Array.isArray(teamData.results)) {
  //       // Process all results for this team
  //       const allPercentages = teamData.results.map(result => {
  //         if (!result.variables) return null;

  //         const variables = {};
  //         result.variables.forEach(variable => {
  //           variables[variable.variable] = variable.score;
  //         });

  //         // Get scores for each quadrant
  //         const heart_r1_m = variables["heart_round1_m"] || 0;
  //         const soul_r1_m = variables["soul_round1_m"] || 0;
  //         const mind_r1_m = variables["mind_round1_m"] || 0;
  //         const strength_r1_m = variables["str_round1_m"] || 0;

  //         const heart_r2_m = variables["heart_round2_m"] || 0;
  //         const soul_r2_m = variables["soul_round2_m"] || 0;
  //         const mind_r2_m = variables["mind_round2_m"] || 0;
  //         const strength_r2_m = variables["str_round2_m"] || 0;

  //         const heart_r1_l = variables["heart_round1_l"] || 0;
  //         const soul_r1_l = variables["soul_round1_l"] || 0;
  //         const mind_r1_l = variables["mind_round1_l"] || 0;
  //         const strength_r1_l = variables["str_round1_l"] || 0;

  //         const heart_r2_l = variables["heart_round2_l"] || 0;
  //         const soul_r2_l = variables["soul_round2_l"] || 0;
  //         const mind_r2_l = variables["mind_round2_l"] || 0;
  //         const strength_r2_l = variables["str_round2_l"] || 0;

  //         // Calculate scores
  //         let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m);
  //         let second_most_score = Math.max(heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m) / 2;
  //         let least_score = Math.max(heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l);
  //         let second_least_score = Math.max(heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l) / 2;

  //         if (least_score >= second_least_score) {
  //           least_score = second_least_score - 1;
  //         }

  //         const total = most_score + second_most_score + least_score + second_least_score;

  //         const most_per = (most_score / total) * 100;
  //         const second_most_per = (second_most_score / total) * 100;
  //         const least_per = (least_score / total) * 100;
  //         const second_least_per = (second_least_score / total) * 100;

  //         const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
  //         const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
  //         const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
  //         const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];

  //         const most_score_label = Math.max(...mostValues);
  //         const second_most_score_label = Math.max(...secondMostValues);
  //         const least_score_label = Math.max(...leastValues);
  //         const second_least_score_label = Math.max(...secondLeastValues);

  //         const labels_arr = ["heart", "soul", "mind", "strength"];
  //         const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

  //         const most_label = getLabel(mostValues, most_score_label);
  //         const second_most_label = getLabel(secondMostValues, second_most_score_label);
  //         const least_label = getLabel(leastValues, least_score_label);
  //         const second_least_label = getLabel(secondLeastValues, second_least_score_label);

  //         const getPercentageOrder = (label) => {
  //           if (label === most_label?.toLowerCase()) return most_per;
  //           if (label === second_most_label?.toLowerCase()) return second_most_per;
  //           if (label === least_label?.toLowerCase()) return least_per;
  //           if (label === second_least_label?.toLowerCase()) return second_least_per;
  //           return 0;
  //         };

  //         return {
  //           strength: getPercentageOrder("strength"),
  //           heart: getPercentageOrder("heart"),
  //           soul: getPercentageOrder("soul"),
  //           mind: getPercentageOrder("mind")
  //         };
  //       }).filter(Boolean); // Remove any null results

  //       if (allPercentages.length > 0) {
  //         // Calculate average percentages across all results
  //         const averagePercentages = {
  //           strength: 0,
  //           heart: 0,
  //           soul: 0,
  //           mind: 0
  //         };

  //         allPercentages.forEach(percentage => {
  //           averagePercentages.strength += percentage.strength;
  //           averagePercentages.heart += percentage.heart;
  //           averagePercentages.soul += percentage.soul;
  //           averagePercentages.mind += percentage.mind;
  //         });

  //         // Calculate final averages
  //         Object.keys(averagePercentages).forEach(key => {
  //           averagePercentages[key] = averagePercentages[key] / allPercentages.length;
  //         });

  //         // console.log("Final average percentages:", averagePercentages);

  //         // Find highest quadrant
  //         let maxPercentage = -1;
  //         let maxQuadrant = '';

  //         Object.entries(averagePercentages).forEach(([quadrant, percentage]) => {
  //           if (percentage > maxPercentage) {
  //             maxPercentage = percentage;
  //             maxQuadrant = quadrant;
  //           }
  //         });

  //         // console.log("Setting highest starter to:", maxQuadrant);
  //         // setHighestStarter(maxQuadrant);
  //         setQuadrantPercentages(averagePercentages);
  //       }
  //     }
  //   }
  // }, [previewData, apiData]);

  useEffect(() => {
    if (!averagePercentages || averagePercentages.length === 0) return;

    const sortedQuadrants = applyFullTieOrder([...averagePercentages].sort(compareQuadrants), (q) => q.name, (q) => q.avg);
    const highestQuadrant = sortedQuadrants[0]?.name?.toLowerCase();

    setHighestStarter(highestQuadrant)
  }, [averagePercentages])


  const getStarterHeading = () => {
    // console.log("Getting starter heading for:", highestStarter);
    if (highestStarter === "heart") return "HEART STARTER";
    if (highestStarter === "strength") return "STRENGTH STARTER";
    if (highestStarter === "soul") return "SOUL STARTER";
    if (highestStarter === "mind") return "MIND STARTER";
    return "NONE";
  };

  const getStarterSections = () => {
    // console.log("Getting starter sections for:", highestStarter);
    if (highestStarter === "heart") return "Heart";
    if (highestStarter === "strength") return "Strength";
    if (highestStarter === "soul") return "Soul";
    if (highestStarter === "mind") return "Mind";
    return "";
  };

  const getStarterLogo = () => {
    // console.log("Getting starter logo for:", highestStarter);
    if (highestStarter === "heart") return HeartIcon;
    if (highestStarter === "strength") return StrengthIcon;
    if (highestStarter === "soul") return SoulIcon;
    if (highestStarter === "mind") return MindIcon;
    return HeartIcon;
  };

  const HighestStarterInfo = () => {
    if (highestStarter === "heart") return "The group is characterized by a Heart Starter dynamic, thriving on deep connections and emotional engagement. As a Heart Starter Group, you are likely to prioritize relationships and are driven by a collective desire to belong. This often motivates the group to form deeper, more meaningful connections both within and outside the group.";
    if (highestStarter === "strength") return `The Strength Starter Group is defined by its action-oriented approach, thriving as doers, drivers, and managers. Motivated by a forward movement that drives tangible results, this group is characterized by being direct, practical, resourceful, and efficient. They uphold a "Capacity for Service" to something greater than themselves, embodying a spirit of dedication and commitment.`;
    if (highestStarter === "soul") return "The Soul Starter Group is defined by its emphasis on depth, creativity, and meaningful insights in its approach to projects and relationships. Driven by the pursuit of meaning, this group often utilizes vision-casting, stories, and metaphors to illuminate the purpose behind their actions and inspire all group members.";
    if (highestStarter === "mind") return `The Mind Starter Group is characterized by its logical orientation, often grounded in structure, strategy, and planning. Motivated by learning, understanding, and information, this group consists of intellectuals, thinkers, engineers, designers, and strategists who see the "Capacity for Understanding" the big picture as essential.`;
    return "";
  };

  const StarterInfo2 = () => {
    if (highestStarter === "heart") return "Capacity for Connection is their fundamental point for action.";
    if (highestStarter === "strength") return "They steward a Capacity for Service to something greater than themselves.";
    if (highestStarter === "soul") return "Capacity for Meaning is their context for everything else.";
    if (highestStarter === "mind") return "Capacity for Understanding the big picture is a necessity.";
    return "";
  };

  const questionSets = {
    heart: [
      "Who needs to be involved in this initiative?",
      "Who fits our culture?",
      "Who can we collaborate with?",
      "Who benefits from our work?"
    ],
    strength: [
      "How will we do it?",
      "How can I succeed?",
      "How will I track progress?",
      "How can we gain momentum?"
    ],
    soul: [
      "Why should we undertake this project?",
      "What is the purpose behind our current strategy?",
      "Why is this goal important to us?",
      "What direction should we pursue and why?"
    ],
    mind: [
      "What do we need to know?",
      "What will we do?",
      "What do you think?",
      "What steps need to happen?"
    ]
  };

  const getQuestion = (index) => questionSets[highestStarter]?.[index] || "";

  const QueOne = () => getQuestion(0);
  const QueTwo = () => getQuestion(1);
  const QueThree = () => getQuestion(2);
  const QueFour = () => getQuestion(3);

  const StrengthsSection = () => {
    if (highestStarter === "heart") return "The Heart Starter Group excels in fostering a supportive and inclusive culture. They are skilled at rallying around common goals and engaging with each other on a level that transcends mere task execution. This focus on emotional connections enhances group cohesion and drives them to share experiences and insights generously, creating a strong communal spirit.";
    if (highestStarter === "strength") return "The Strength Starter Group excels in transforming intangible ideas into tangible products and activities. Known for their speed, resourcefulness, and efficiency, they are adept at assessing challenges, rallying resources, and leading initiatives. Their superpower lies in their ability to act decisively, driven by a commitment to serve and achieve practical outcomes.";
    if (highestStarter === "soul") return "The Soul Starter Group excels in vision and innovation, leveraging deep insights and creative approaches to address complex challenges. They are adept at offering perspective and wisdom, inspiring the group through compelling narratives and visionary ideas. Their ability to see and articulate a deeper meaning not only motivates them but also serves as a guiding light in their endeavors, making them effective mentors and leaders within the organization.";
    if (highestStarter === "mind") return "The Mind Starter Group excels in bringing plans, policies, principles, and structured beliefs to the forefront of their approach. Known for their analytic problem-solving abilities, they find energy and fulfillment in simplifying complex issues and breaking them down into manageable parts. Their communication may be more factual and less emotive, but its clarity, organization, and focus on strategic outcomes make it exceptionally effective.";
    return "";
  };

  const ChallengesSection = () => {
    if (highestStarter === "heart") return "While the capacity for empathy and connection is a significant asset, it can sometimes lead to challenges. The group may become overly attached to consensus or emotional agreement, potentially at the expense of decisiveness or efficiency. A deep sense of empathy can also lead the group to take on more emotional burdens than is sustainable, which may affect overall productivity and focus.";
    if (highestStarter === "strength") return "However, their focus on action and results can sometimes lead to challenges in maintaining deeper relationships and emotional connections. The group's sense of urgency might prompt premature actions without thoroughly planned strategies, potentially leading to tangible setbacks in projects and affecting the entire organization. Their directness may also be perceived as harshness, especially under stress.";
    if (highestStarter === "soul") return "Their focus on ideas and ideals can sometimes lead to challenges in execution. The Soul Starter Group may struggle with the granularity of day-to-day tasks and can become overwhelmed by the mundane aspects of project management. Their need for meaningful engagement can also result in hesitation or withdrawal when faced with misunderstood or undervalued ideas, potentially leading to isolation or a lack of decisive action.";
    if (highestStarter === "mind") return "The group’s focus on flawless execution of systems and strategies may sometimes overlook the human element, leading others to perceive them as detached or overly calculated. They might struggle with empathy and understanding in emotionally charged situations. Additionally, their meticulous nature can cause delays as they seek to gather more data, potentially leading to information overload without effective organization or communication strategies.";
    return "";
  };

  const overallSectionMap = {
    heart: "Overall, a Heart Starter Group is a powerful cultural force for creating a positive and connected work environment, ensuring that every member feels valued and heard.",
    strength: "Overall, the Strength Starter Group is a dynamic force within the organization, driving projects from conception to completion with vigor and determination. Their commitment to service and action makes them invaluable in executing and managing tasks that require immediate and impactful results.",
    soul: "Overall, the Soul Starter Group contributes a unique and invaluable perspective that enhances the organizational culture and projects. They are committed to not only envisioning a better future but also to sharing that vision in ways that foster growth and understanding across the group.",
    mind: "Overall, the Mind Starter Group contributes significantly to the organization by providing structured approaches and strategic insights that enhance decision-making and project execution. Their ability to dissect and understand complex scenarios is a valuable asset to any organization."
  };

  const OverallSection = () => overallSectionMap[highestStarter] || "";

  return (
    <div>
      <HeaderPreview />
      <div className="heart-starter-container">
        <h2>GROUP PROFILE: {getStarterHeading()}</h2>
        <div className="heart-starter-content">
          <div className="heart-icon">
            <img src={getStarterLogo()} alt="Heart Icon" />
          </div>
          <div className="heart-description">
            {HighestStarterInfo()}
            {/*StarterInfo2()*/}
          </div>
        </div>
        <div className="heart-starter-details">
          <div className="questions-section">
            <h5>Core questions guiding the group:</h5>
            <div className="questions-container">
              <div className="questions-column">
                <ul>
                  <li>{QueOne()}</li>
                  <li>{QueTwo()}</li>
                </ul>
              </div>
              <div className="questions-column">
                <ul>
                  <li>{QueThree()}</li>
                  <li>{QueFour()}</li>
                </ul>
              </div>
            </div>
          </div>


          <div className="strengths-section">
            <h5><strong>Strengths:</strong></h5>
            <p>
              {StrengthsSection()}
            </p>
          </div>

          <div className="challenges-section">
            <h5><strong>Challenges:</strong></h5>
            <p>
              {ChallengesSection()}
            </p>
          </div>

          <div className="questions-section overall-section">
           <p>
               {OverallSection()}
           </p>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  )
}
